import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'

Vue.use(Router)

function loadView (view, isAdmin) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/${isAdmin ? 'admin' : 'views'}/${view}.vue`)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      alias: '/index.html',
      name: 'home',
      component: Home,
      meta: { title: 'Bedriftsmedlem', requiresAuth: true },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { title: 'Logg inn' },
      props (route) {
        if (route.query.email) {
          window.skipEmailVerification = true
          window.codeFromEmail = route.query.code
        }

        return {
          newUser: route.query.email,
        }
      },
    },
    {
      path: '/employee',
      name: 'employee',
      component: loadView('Employee'),
      meta: { title: 'Mitt Firma', back: true, requiresAuth: true },
    },
    {
      path: '/profile',
      name: 'profile',
      component: loadView('Profile'),
      meta: { title: 'Min Profil', back: true, requiresAuth: true },
    },
    {
      path: '/company',
      name: 'company',
      component: loadView('Company'),
      meta: { title: 'Mitt Firma', back: true, requiresAuth: true },
    },
    {
      path: '/users',
      name: 'users',
      component: loadView('Users'),
      meta: { title: 'Ansatte', back: true, requiresAuth: true },
    },
    {
      path: '/register',
      name: 'register',
      component: loadView('Register'),
      meta: { title: 'Fullfør registrering', requiresAuth: true },
    },
    {
      path: '/admin',
      name: 'admin',
      component: loadView('Admin'),
      meta: { title: 'Administrasjon', back: true, requiresAuth: true },
    },
    { path: '*', redirect: '/' },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.user.isLoggedIn) {
    next({ name: 'login' })
  } else if (to.name !== 'register' && store.state.user.isLoggedIn && (!store.state.user.data || !store.state.user.data.fullname)) {
    next({ name: 'register' })
  } else next()
})


export default router
